import { createContext } from 'react';
import { LiveTicketsType } from 'src/types';

export const TicketLiveDataContext = createContext<LiveTicketsType | undefined>(
  {} as LiveTicketsType
);

export const TicketDataProvider = TicketLiveDataContext.Provider;
